import styled from '@/styles';

export const PageShell = styled('div', {
  padding: '24px 24px 100px',
  boxSizing: 'border-box',
  maxWidth: 802,
  margin: '0 auto',
  width: '100%',
  fontFamily: "'Manrope', sans-serif",
});

export const StepHeading = styled('p', {
  fontSize: 18,
  fontWeight: 700,
  color: '#1C1C1C',
  margin: '0 0 8px 0',
  fontFamily: "'Manrope', sans-serif",
});

export const StepSubheading = styled('p', {
  fontSize: 14,
  fontWeight: 400,
  color: '#5C5C5C',
  margin: '0 0 24px 0',
  fontFamily: "'Manrope', sans-serif",
});

export const JobList = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

export const RateCard = styled('div', {
  background: '#fff',
  border: '1px solid #DADADA',
  borderRadius: 8,
  padding: 24,
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

export const CardTopRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 16,
  flexWrap: 'wrap',
});

export const SkillTitle = styled('p', {
  fontSize: 16,
  fontWeight: 700,
  color: '#1C1C1C',
  margin: 0,
});

export const TotalHoursLabel = styled('div', {
  display: 'flex',
  alignItems: 'baseline',
  gap: 8,
  color: '#5C5C5C',
  fontSize: 14,

  '& strong': {
    color: '#1C1C1C',
    fontWeight: 700,
    fontSize: 16,
  },
});

export const RateRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 16,
  paddingTop: 16,
  borderTop: '1px solid #EAEAEA',
});

export const RateLabel = styled('p', {
  fontSize: 14,
  fontWeight: 600,
  color: '#1C1C1C',
  margin: 0,
});

export const RateInputShell = styled('div', {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  border: '1px solid #DADADA',
  borderRadius: 6,
  padding: '8px 12px',
  minWidth: 140,
  background: '#fff',
});

export const RateInputDollar = styled('span', {
  fontSize: 18,
  fontWeight: 700,
  color: '#1C1C1C',
});

export const RateInput = styled('input', {
  border: 'none',
  outline: 'none',
  fontSize: 18,
  fontWeight: 700,
  color: '#1C1C1C',
  textAlign: 'right',
  width: '100%',
  fontFamily: "'Manrope', sans-serif",
  padding: 0,
  background: 'transparent',
});

export const RatingRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  fontSize: 13,
  fontWeight: 500,

  variants: {
    tone: {
      bad: { color: '#DC1515' },
      avg: { color: '#EC7F00' },
      good: { color: '#45A735' },
      neutral: { color: '#5C5C5C' },
    },
  },
});

export const RatingDot = styled('span', {
  width: 10,
  height: 10,
  borderRadius: '50%',
  display: 'inline-block',

  variants: {
    tone: {
      bad: { background: '#DC1515' },
      avg: { background: '#EC7F00' },
      good: { background: '#45A735' },
      neutral: { background: '#979797' },
    },
  },
});

export const MutedNote = styled('p', {
  fontSize: 12,
  color: '#979797',
  margin: 0,
});
